import React, { useEffect, useState } from "react";
import { Box, Grid, Pagination, LinearProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {SearchBarComponent} from "../../../component/atom";
import {SampleVideoCard} from "../../../component/molecule";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import { Actions } from "../../../core/modules/Actions";
import { connect } from "react-redux";
import _ from "lodash";
import DropDownComponent from "../../../component/atom/Inputs/DropDown";
import { getText } from "../../../core/Constant";

const WebinarMainScreen = ({
  getWebinar,
  webinarList,
  verifyToken,
  getStdCourseList,
  stdCourseList,
}) => {
  const navigate = useNavigate();
  const [value, setValue] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [newcourseList, setCourseList] = useState([]);
  const [course, setCourse] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchWebinars = async ({
    page = 1,
    per_page = rowsPerPage,
    course: selectedCourse = course,
    search = searchValue,
  } = {}) => {
    setLoading(true);
    await getWebinar({
      course: selectedCourse,
      page,
      per_page,
      search,
    });
    setLoading(false);
  };

  const handlePageChange = (_, value) => {
    setCurrentPage(value);
    fetchWebinars({
      page: value,
      per_page: rowsPerPage,
      course,
      search: searchValue,
    });
  };

  const searchInput = (newvalue) => {
    setSearchValue(newvalue);
    setCurrentPage(1);
    fetchWebinars({
      page: 1,
      per_page: rowsPerPage,
      course,
      search: newvalue,
    });
  };

  useEffect(() => {
    getStdCourseList();
  }, []);

  useEffect(() => {
    const list = _.map(stdCourseList, (item) => ({
      id: parseInt(item.course_id, 10),
      course_id: parseInt(item.course_id, 10),
      name: item.course_name,
    }));
    setCourseList(list);
    const defaultCourse = list[0]?.id;
    setCourse(defaultCourse);
    fetchWebinars({
      page: 1,
      per_page: rowsPerPage,
      course: defaultCourse,
      search: "",
    });
  }, [stdCourseList, rowsPerPage]);

  useEffect(() => {
    const responseItems = _.get(webinarList, "data", webinarList);
    const items = Array.isArray(responseItems)
      ? responseItems
      : _.get(responseItems, "data", []);
    const grouped = _.values(_.groupBy(items, "week"));

    setValue(grouped);

    const total = _.get(webinarList, "total", items.length);
    const perPageFromApi = _.get(webinarList, "per_page", rowsPerPage);

    setTotalItems(total);
    setRowsPerPage(perPageFromApi);

    if (total && perPageFromApi) {
      setTotalPages(Math.ceil(total / perPageFromApi));
    } else if (_.get(webinarList, "last_page")) {
      setTotalPages(webinarList.last_page);
    } else {
      setTotalPages(Math.max(1, Math.ceil(items.length / rowsPerPage)));
    }
  }, [webinarList]);

  const onCourseChange = (e) => {
    const Selectedvalue = parseInt(getText(e), 10);
    setCourse(Selectedvalue);
    localStorage.setItem("firstcourse", Selectedvalue.toString());
    setCurrentPage(1);
    fetchWebinars({
      page: 1,
      per_page: rowsPerPage,
      course: Selectedvalue,
      search: searchValue,
    });
  };

  const onViewVideo = (item) => {
    navigate("/course-video", { state: { course: item } });
  };

  return (
    <>
      <Grid className="main-screen-container" container flexDirection={"column"} rowSpacing={1}  mt={2}>
        <Grid item>
          <Grid container justifyContent={"space-between"}>
            <Grid item>
              <HeadingComponent
                text={"Webinar Archive"}
                size={"26px"}
                color={"#2d3945"}
                fontfamily={"Montserrat"}
                fontweigth={600}
              />
            </Grid>
            <Grid item>
              <Grid container alignItems={"center"}>
                <Grid item>
                  <DropDownComponent
                    isShowPlaceholder={true}
                    isShowZero={false}
                    initialValue="Select Course"
                    onchange={onCourseChange}
                    radius={"15px"}
                    list={newcourseList}
                    selectedValue={course}
                  />
                </Grid>
                <Grid item>
                  <SearchBarComponent
                    value={searchValue}
                    onchange={(e) => searchInput(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container flexDirection={"column"} >
            {loading ? (
              <Box sx={{ width: '100%', mt: 2 }}><LinearProgress /></Box>
            ) : (
              value.map((item, index) => {
                const week = item[0]?.week;
                return (
                  <Grid item xs={12} key={week || index}>
                    <Box mb={3}>
                      <p className="week-text">{week}</p>
                    </Box>
                    <Grid container rowGap={2} columnGap={3}>
                      {item?.map((value, count) => {
                        return value?.day != "0" ? (
                          <Grid item key={value.id || count}>
                            <SampleVideoCard
                              onViewVideo={() => onViewVideo(value)}
                              thumbnail={value?.thumbnail}
                              videoUrl={value?.content_link}
                              description={
                                value?.week + " - " + "Day " + value?.day
                              }
                              btnText={"Watch"}
                              title={value?.content}
                            />
                          </Grid>
                        ) : null;
                      })}
                    </Grid>
                  </Grid>
                );
              })
            )}
          </Grid>
        </Grid>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <Box mt={3} display="flex" justifyContent="center">
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              shape="rounded"
              showFirstButton
              showLastButton
              disabled={loading}
            />
          </Box>
        )}
      </Grid>
    </>
  );
};

export default connect(
  (state) => ({
    webinarList: state.webinar.get("webinarList"),
    stdCourseList: state.course.get("stdCourseList"),
  }),
  {
    getWebinar: Actions.webinar.getWebinar,
    verifyToken: Actions.auth.verifyToken,
    getStdCourseList: Actions.course.getStdCourseList,
  }
)(WebinarMainScreen);
